// Drag-and-drop nativo para o Kanban - sem libs externas.
// State global compartilhado por todas as instâncias do composable.
import { reactive } from 'vue';

const state = reactive({
  draggingLeadId: null,
  fromStageId: null,
  dragOverStageId: null,
});

export function useKanbanDnd() {
  function onDragStart(event, lead, fromStageId) {
    state.draggingLeadId = lead.id;
    state.fromStageId = fromStageId;
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', String(lead.id));
  }

  function onDragEnd() {
    state.draggingLeadId = null;
    state.fromStageId = null;
    state.dragOverStageId = null;
  }

  function onDragOver(event, stageId) {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    state.dragOverStageId = stageId;
  }

  function onDragLeave(_event, stageId) {
    if (state.dragOverStageId === stageId) state.dragOverStageId = null;
  }

  async function onDrop(event, stageId, onMove) {
    event.preventDefault();
    const leadId = state.draggingLeadId;
    const fromStageId = state.fromStageId;
    onDragEnd();
    if (!leadId || fromStageId === stageId) return;

    try {
      await onMove({ leadId, fromStageId, toStageId: stageId });
    } catch (e) {
      console.error('[useKanbanDnd] move failed', e);
      throw e;
    }
  }

  return { state, onDragStart, onDragEnd, onDragOver, onDragLeave, onDrop };
}
